import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-h-11 min-h-0 min-w-0 overflow-hidden font-primary font-medium break-words" }

interface Props {
  title: string
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ReferenceTitle'
},
  __name: 'ReferenceTitle',
  props: {
    title: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(__props.title), 1))
}
}

})